export default __webpack_public_path__ + "e20a994a31530192d52f4db94b9c0802.svg";